import uiReducers from './reducers';
import * as uiActions from './actions';

export { uiActions };
export default uiReducers;
